import { Component, Output, HostListener, ElementRef, Input, EventEmitter, ViewChild, ViewContainerRef, ChangeDetectorRef, ComponentFactoryResolver } from '@angular/core';
import { NavController, NavParams, Events, ToastController, ModalController } from 'ionic-angular';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { VerticalTabComponent } from '../../components/vertical-tab/vertical-tab';
import { StoreWrapProvider } from '../../providers/store-wrap/store-wrap';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service';

const mobileWidth = 520;
@Component({
  selector: 'header-detail',
  templateUrl: 'header-detail.html'
})
export class HeaderDetailComponent {
  @ViewChild('headerComponentHolder', { read: ViewContainerRef, static: false }) headerComponentHolder: ViewContainerRef;
  @ViewChild('footerComponentHolder', { read: ViewContainerRef, static: false }) footerComponentHolder: ViewContainerRef;
  @ViewChild('detailComponentHolder', { read: ViewContainerRef, static: false }) detailComponentHolder: ViewContainerRef;
  @ViewChild('loadTrackComponent', { read: ViewContainerRef, static: false }) loadTrackComponent: ViewContainerRef;

  footerActive: any = false;
  @Input() isChildForm: any;
  @Input() field: any;
  @Input() sourceField: any;
  @Input() parentForm: any;
  @Output() tabTemplateName = new EventEmitter();
  @Input() params: any;
  @Input() accessType: any;
  @Input() gridParam: any;
  @Input() templateName: any;
  @Input() dataAccessType: any;
  @Input() screenProps: any;
  @Input() tabTemplates: any = [];
  broadcastSubs: any;
  headerClose: boolean;
  headerOpen: boolean = true;
  @Input() set multiSelectedTemplate(v: any) {
    this.tabTemplates = v;
  };
  detailCompParams: any;
  codeData: { 'Code': any; 'accessType': any; };

  unsubcribe: any;
  formData: any = {};
  formFields: any = {};
  paramData: any;
  headerTemaplateConfig: any;
  detailTemplateConfig: any = [];
  components: any;
  componentRef: any;
  formLayout: any = [];

  fields: any = [];
  setHeaderHeight: any = 40;
  rootParams: any;
  navTemplate: any;
  chatOpen: any = false;
  public form: FormGroup;

  screenPropsVal: any;
  templateGroup: any[];
  templateSummaryGroup: any[];
  pullParams: any;
  formLayoutArr: any[];
  templateProps: any[];
  summaryDataArr: any;
  index: any = 0;
  screen: any = 'web';
  headerFormProps: any;
  formAccessType: any;
  constructor(public communicationServ: CommunicationServiceProvider, public configApiService: ConfigApiServiceProvider, private storeWrap: StoreWrapProvider, public navCtrl: NavController, private cdr: ChangeDetectorRef, public navParams: NavParams, public events: Events, private componentFactoryResolver: ComponentFactoryResolver, public driveService: DriveServiceProvider, public toastController: ToastController, private resolver: ComponentFactoryResolver, private modal: ModalController) {

    /* * * * * * * * * *
 * Get app componets
 * * * * * * * * * */
    this.initDriveEvents();
  }

  initDriveEvents() {
    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "comp-main") {
          if (data.event === 'getAppComponents') {
            let flag = data['status'];
            let components = data['components']
            if (flag) {
              this.components = components;
            }
          }
        } else if (data.src === 'defaultProps') {
          if (data.event === 'pushParamsValue') {
            this.params = data.params;
            this.dataAccessType = "editdata";
            this.tabTemplates = [];
            this.driveService.objCurrentFolder.template.forEach(element => {
              this.tabTemplates.push(this.storeWrap.storeTemplates[element.id]);
            });
            this.detailTemplateConfig = [];
            this.headerTemaplateConfig = this.getHeaderScreen(this.tabTemplates);
            if (this.tabTemplates.length > 1 && this.headerTemaplateConfig) {
              this.getDefaultFormConfig();
            }
          }
        }
      })
  }

  ngOnInit() {
    // this.components = this.componentService.getComponents();
    /* * * * * * * * * *
    * pull app componets
    * * * * * * * * * */
    this.driveService.broadcastInfo({ src: 'defaultProps', event: 'pullAppComponents', status: true });

    this.headerTemaplateConfig = this.getHeaderScreen(this.tabTemplates);
    if (this.screenProps != undefined) {
      this.formLayout = this.screenProps['formLayout'];
      this.form = new FormGroup({
        fields: new FormControl(JSON.stringify(this.formLayout))
      })

      this.unsubcribe = this.form.valueChanges.subscribe((update) => {

        this.formLayout = this.validateFormLayout(JSON.parse(update.fields));
      });

    } else {
      this.screenProps = {};
      this.screenProps['formLayout'] = [[{ "fields": [], "Id": "", "layoutName": "", "isVisibleHeader": "NO", "props": "" }]];
    }



  }


  ngAfterViewInit() {
    if (window.innerWidth > 700) {
      this.screen = 'web';
    } else {
      this.screen = 'mobile';
    }
    this.getDefaultFormConfig();
    setTimeout(() => {
      if (this.detailTemplateConfig.length > 1) {
        this.loadComponent();
      } else if (this.detailTemplateConfig.length == 1) {
        if (this.detailTemplateConfig[0]["componentName"] == "FormGridComponent" || this.detailTemplateConfig[0]["componentName"] == 'SEARCHGRID') {
          this.loadFormGridComponent(this.detailTemplateConfig[0]);
        } else {
          this.loadDefaultDetailComponent(this.params, this.detailTemplateConfig[0]);
        }
      } else {
        this.openNavChat();
      }
    }, 1000);

    // setTimeout(() => {
    //   if (this.headerFormProps != undefined) {
    //     this.openHeaderForm(this.headerFormProps);
    //   }
    // }, 1500);
    this.cdr.detectChanges();

    this.events.subscribe('openHeaderForm', (status, screenProps, formAccessType) => {
      if (status) {
        this.headerFormProps = screenProps;
        this.formAccessType = formAccessType;
        if (this.formAccessType == 'new') {
          this.events.unsubscribe('openHeaderForm');
          if (this.driveService.recruitmentFlag != true) {
            this.driveService.recruitmentFlag = status;
            this.openHeaderForm(this.headerFormProps);
          }
        }
      }
    });

    this.events.subscribe('EditHeaderForm', (status, screenProps, formAccessType) => {
      this.headerFormProps = screenProps;
      this.formAccessType = formAccessType;
      if (status) {
        this.openHeaderForm(this.headerFormProps);
      }
    });
  }


  // try { this.events.unsubscribe('openHeaderForm'); } catch(err) { //use this if you need to know when this is called probably only once } events.subscribe('<event identifier>', () => { });




  ngOnDestroy() {
    this.driveService.recruitmentFlag = false
    this.events.unsubscribe('openHeaderForm');
    this.events.unsubscribe('pushParamsValue');
  }

  /* * * * * * *
  * get header screen
  * * * * * * */
  getHeaderScreen(templates) {
    let header: any;
    templates.forEach((template, index) => {
      if (template['pluginData']) {
        let pluginData = JSON.parse(template['pluginData'])
        const headerTemp = Object.keys(pluginData).some(plugin=> plugin.toLowerCase() === 'header')
        if (headerTemp) {
          header = template;
          localStorage.setItem('headerTemp',JSON.stringify(template));
        } else {
          this.detailTemplateConfig.push(template);
        }
      } else {
        this.detailTemplateConfig.push(template);
      }
    });
    return header;
  }

  getComponent(name) {
    for (let i = 0; i < this.components.length; i++) {
      let item = this.components[i];
      if (item.compName === name) {

        return item;
      }
    };
    return null;
  }

  /* * * * * * *
  * Default Component
  * * * * * * */
  getDefaultFormConfig() {

    if (this.headerTemaplateConfig != undefined) {
      let component: any = this.getComponent(this.headerTemaplateConfig.componentName);
      let pluginData = JSON.parse(this.headerTemaplateConfig.pluginData);
      if (!component) {
        this.driveService.fetchScreenProperties(this.params, this.headerTemaplateConfig.id, (screenProps, gridRowData = null) => {
          this.detailCompParams = gridRowData;
          localStorage.setItem('RowData',JSON.stringify(gridRowData));
          if (this.dataAccessType === "newdata") {
            let formLayout = this.driveService.clearFormLayoutData(screenProps['formLayout'], this.params, 'header');
            this.screenProps['formLayout'] = formLayout;
          }
          this.screenProps = screenProps;
          this.loadHeaderComponent(null, pluginData);
        });
      } else if (component) {
        this.driveService.fetchScreenProperties(this.params, this.headerTemaplateConfig.id, (screenProps, gridRowData = null) => {
          if (this.dataAccessType === "newdata") {
            let formLayout = this.driveService.clearFormLayoutData(screenProps['formLayout'], this.params, 'header');
            this.screenProps['formLayout'] = formLayout;
          }
          this.screenProps = screenProps;
          this.loadHeaderComponent(component, pluginData);

          // if(pluginData.hasOwnProperty('footer')){
          //   this.footerActive = true;
          //   setTimeout(() => {
          //   this.loadFooterComponent(component);
          //   },100);
          // }          
        });
      }
    }
  }

  /* * * * * * *
  * load tab Component
  * * * * * * */
  loadComponent() {
    this.detailComponentHolder.clear();
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(VerticalTabComponent);
    this.componentRef = this.detailComponentHolder.createComponent(componentFactory);
    this.componentRef.instance.components = this.components;
    this.componentRef.instance.tabTemplates = this.detailTemplateConfig;
    this.componentRef.instance.params = this.params;
    this.componentRef.instance.templateName = this.templateName;
    this.componentRef.instance.accessType = this.accessType;
    this.componentRef.instance.gridParam = this.gridParam;
    this.componentRef.instance.headerFormFields = this.formFields;
    this.componentRef.instance.screenProps = this.screenProps; this
    this.componentRef.instance.detailCompParams = this.detailCompParams;
    this.componentRef.instance.dataAccessType = this.dataAccessType;
    this.componentRef.instance.tabTemplateName.subscribe((event) => { this.templateName = event; });
    this.codeData = { 'Code': this.params, 'accessType': this.accessType };
  }

  /* * * * * * *
  * Header Component
  * * * * * * */
  loadHeaderComponent(objComponent = null, pluginData = null) {
    let component: any
    if (objComponent) {
      component = objComponent;
    } else {
      if (this.screenProps.componentName != 'FORM') {
        component = this.getComponent(this.screenProps.componentName);
      }

    }
    //Commented for Share UI Issue
    //this.setHeaderHeight = 69;
    this.setHeaderHeight = 69;
    if (!component) {
      this.setHeaderHeight = 60;
      if (window.innerWidth < mobileWidth) {
        this.setHeaderHeight = 60;
      }
      component = this.getComponent('defaultHeader');
    }
    this.headerComponentHolder.clear();
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
    this.componentRef = this.headerComponentHolder.createComponent(componentFactory);
    this.componentRef.instance.formLayout = this.screenProps.formLayout;
    this.driveService.headerDetail = this.screenProps.formLayout;
    this.componentRef.instance.screenProps = this.screenProps;
    this.componentRef.instance.form = this.assignFormFields();
    this.componentRef.instance.formFields = this.getFormFieldsData();
    this.componentRef.instance.onSubmit = this.saveFormData.bind(this);
    this.componentRef.instance.adminAccess = this.driveService.adminAccess;
    this.componentRef.instance.detailCompParams = this.detailCompParams;
    this.componentRef.instance.components = this.components;
    this.componentRef.instance.header = true;
    if (this.componentRef.instance.getManagerDetail) {
      this.componentRef.instance.getManagerDetail.subscribe((event) => { this.getManagerDetail(event); });
    }
    if (this.componentRef.instance.profileUploadImage) {
      this.componentRef.instance.profileUploadImage.subscribe((event) => { this.profileUploadImage(event); });
    }
    if (pluginData.hasOwnProperty('footer')) {
      this.footerActive = true;
      setTimeout(() => {
        // this.loadFooterComponent(component);
      }, 100);
    }
  }

  loadFooterComponent(objComponent = null) {
    let component: any
    if (objComponent) {
      component = objComponent;
    } else {
      component = this.getComponent(this.screenProps.id + '-customForm');
    }
    this.setHeaderHeight = 60;
    if (window.innerWidth < mobileWidth) {
      this.setHeaderHeight = 60;
    }
    if (!component) {
      this.setHeaderHeight = 60;
      if (window.innerWidth < mobileWidth) {
        this.setHeaderHeight = 60;
      }
      component = this.getComponent('defaultHeader');
    }
    this.footerComponentHolder.clear();
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
    this.componentRef = this.footerComponentHolder.createComponent(componentFactory);
    this.componentRef.instance.formLayout = this.screenProps.formLayout;
    this.componentRef.instance.screenProps = this.screenProps;
    this.componentRef.instance.form = this.assignFormFields();
    this.componentRef.instance.formFields = this.getFormFieldsData();
    this.componentRef.instance.onSubmit = this.saveFormData.bind(this);
    this.componentRef.instance.adminAccess = this.driveService.adminAccess;
    this.componentRef.instance.gridParam = this.gridParam;
    this.componentRef.instance.detailCompParams = this.detailCompParams;
    this.componentRef.instance.footer = true;
    if (this.componentRef.instance.getManagerDetail) {
      this.componentRef.instance.getManagerDetail.subscribe((event) => { this.getManagerDetail(event); });
    }
    if (this.componentRef.instance.profileUploadImage) {
      this.componentRef.instance.profileUploadImage.subscribe((event) => { this.profileUploadImage(event); });
    }
  }

  profileUploadImage(objData) {

    this.events.publish('updateProfileImage', true, objData);
  }

  getManagerDetail(val) {
    this.params = { [this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey]: val['Manager_' + this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey] };
    if (this.tabTemplates.length > 1 && this.headerTemaplateConfig) {
      this.getDefaultFormConfig();
      if (this.detailTemplateConfig.length > 1) {
        this.driveService.broadcastInfo({ src: 'header-detail', event: 'pushHeaderLink', params: this.params });
      } else if (this.detailTemplateConfig.length == 1) {
        if (this.detailTemplateConfig[0]["componentName"] == "FormGridComponent" || this.detailTemplateConfig[0]["componentName"] == 'SEARCHGRID') {
          this.loadFormGridComponent(this.detailTemplateConfig[0]);
        } else {
          this.loadDefaultDetailComponent(this.params, this.detailTemplateConfig[0]);
        }
      }
    }
  }

  /* * * * * * *
  * Detail Default Component
  * * * * * * */
  loadDefaultDetailComponent(param, templateProperty) {
    let component = this.getComponent(templateProperty.componentName);
    if (!component) {
      component = this.components[0];
    }
    let sourceKey: any;
    let parentScreenParam: any;
    /* * * * * *
     * script for get child template plugin srckey 
     *  * * * * */
    let pluginSrcKey = JSON.parse(templateProperty['pluginData']);
    if (pluginSrcKey['srcKey']) {
      var plugin = pluginSrcKey['srcKey'];
      parentScreenParam = { [plugin.childKey]: this.params[plugin.parentKey] }
    } else {
      if (this.driveService.objCurrentFolder.template.length > 1) {
        sourceKey = this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey;
      } else {
        sourceKey = templateProperty.sourceKey;
      }
      parentScreenParam = { [sourceKey]: this.params[sourceKey] };
    }

    this.driveService.fetchScreenProperties(parentScreenParam, templateProperty.id, (screenProps, gridRowData = null) => {
      this.detailComponentHolder.clear();
      let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
      if (!componentFactory) {
        componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
      }
      this.componentRef = this.detailComponentHolder.createComponent(componentFactory);
      this.componentRef.instance.params = parentScreenParam;
      this.componentRef.instance.templateName = screenProps.id;
      this.componentRef.instance.accessType = this.accessType;
      this.componentRef.instance.screenProps = screenProps;
      this.componentRef.instance.components = this.components;
      this.componentRef.instance.gridParam = this.gridParam;
      this.componentRef.instance.detailCompParams = this.detailCompParams;
      this.componentRef.instance.headerFormFields = this.formFields;
      if (this.components[0].compName != component.compName && templateProperty.componentName != 'FormGridComponent' && templateProperty.componentName != 'SEARCHGRID') {
        this.events.publish('tabTrigger', true);
        this.loadSummaryList(screenProps, parentScreenParam);
      }
      setTimeout(() => {
        // this.events.publish('loadCustomComponent',true);
        this.events.publish('enableDefaultFromNewButton', true);
      }, 100);
    });
  }

  loadSummaryList(templateProperty, params) {
    if (templateProperty.componentName != 'FormGridComponent' && this.screenProps.componentName != 'SEARCHGRID') {
      this.formLayoutArr = [];
      this.templateProps = [];
      this.index = 0;

      this.templateGroup = this.getTemplateGroup(templateProperty);
      this.pullParams = this.getPullParams(templateProperty, params);
      this.configApiService.pullSummaryListRequest(this.pullParams, (summaryResponse) => {
        this.summaryDataArr = summaryResponse;
        this.getFormLayoutMultipleTemplate(params, (formLayoutArr) => {

          this.driveService.setMutiTemplateFormData(this.formLayoutArr, (formObj) => {
            this.driveService.getFormFieldsData(this.formLayoutArr, (formFields) => {
              var multiTemplateProps = Object.assign({}, { "templateGroup": this.templateGroup, "templateSummaryGroup": this.templateSummaryGroup, "pullParams": this.pullParams, "summaryDataArr": this.summaryDataArr, "formLayoutArr": this.formLayoutArr, "templateProps": this.templateProps, "formObj": formObj, "formFields": formFields });
              this.events.publish('tabTriggerDataToCustomApplication', true, templateProperty, params, this.accessType, multiTemplateProps);
            });
          });
        });
      });
    } else {
      this.driveService.fetchScreenProperties(params, templateProperty.id, (screenProps, gridRowData = null) => {
        // this.events.publish('tabTriggerDataToGridApplication', true, screenProps.id, screenProps, params, this.accessType, this.components, gridRowData, true);
        this.driveService.broadcastInfo({ src: 'form-grid', event: 'tabTriggerDataToGridApplication', status: true, screenProps: screenProps.id, parentScreenParam: params, accessType: this.accessType, components: this.components, gridRowData: gridRowData, rowDataStatus: true });

      });
    }
  }
  /* * * * * *
  * get FormLayout properties for multiple template
  * * * * * */
  startFetchLayout(parentScreenParam, cbck) {
    let templateID = this.templateGroup[this.index]
    var rowData = this.summaryDataArr[this.index];
    if (rowData.length > 0) {
      rowData = rowData[0];
    } else {
      rowData = {};
    }

    this.driveService.fetchTemplateProperties(parentScreenParam, rowData, templateID, (templatePops) => {
      this.templateProps.push(templatePops);
      this.formLayoutArr.push(templatePops['formLayout']);
      this.index++;
      this.getFormLayoutMultipleTemplate(parentScreenParam, cbck);
    });
  }
  /* * * * * *
  * get FormLayout properties for multiple template
  * * * * * */
  getFormLayoutMultipleTemplate(parentScreenParam, cbck) {
    let len = this.templateGroup.length - 1;
    if (this.index > len) {
      cbck(this.formLayoutArr);
    } else {
      this.startFetchLayout(parentScreenParam, cbck)
    }
  }

  /* * * * * *
  * get template data
  * * * * * */
  getPullParams(screenProps, parentScreenParam) {
    var templatePops;
    this.pullParams = Object.assign({}, screenProps.fieldParams, { "PushArray": [] });
    this.templateGroup.forEach((templateID) => {
      templatePops = this.driveService.storeWrap.storeTemplates[templateID];
      var obj = {};
      if (templateID === 'main_empcommunicationdetails600') {
        obj = Object.assign({}, templatePops.pullParams, parentScreenParam, { "addresstype": 6, "apiType": "Summary" });
      } else {
        obj = Object.assign({}, templatePops.pullParams, parentScreenParam, { "apiType": "Summary" });
      }
      this.pullParams['PushArray'].push(obj);
    });
    return this.pullParams;
  }

  /* * * * * *
  * get template group data
  * * * * * */
  getTemplateGroup(template) {

    this.templateGroup = [];
    if (template['pluginData']) {
      let pluginData = JSON.parse(template['pluginData'])
      if (pluginData['templateGroup']) {
        this.templateGroup = pluginData['templateGroup'];
      } if (pluginData['templateSummaryGroup']) {
        this.templateSummaryGroup = pluginData['templateSummaryGroup'];
      }
    }
    return this.templateGroup;
  }


  /* * * * * * *
  * FoemGird Component
  * * * * * * */
  loadFormGridComponent(templateProperty) {
    this.templateName = templateProperty.templateName;
    this.paramData = this.params;
    this.rootParams = { selectedData: { 'screenProps': templateProperty, 'params': this.params, 'accessType': templateProperty.accessType, 'templateName': templateProperty.templateName } };
    let parentScreenParam = {};
    if (this.driveService.objCurrentFolder.template.findIndex(element => element.id == this.rootParams.selectedData.screenProps.id) > 0) {
      let sourceKey = this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey
      parentScreenParam = { [sourceKey]: this.params[sourceKey] };
    } else {
      if (this.rootParams.selectedData.screenProps.sourceKey.length > 1) {
        this.rootParams.selectedData.screenProps.sourceKey.forEach(element => {
          if (this.params.hasOwnProperty(element)) {
            parentScreenParam[element] = this.params[element];
          }
        });
      } else {
        parentScreenParam[this.rootParams.selectedData.screenProps.sourceKey] = this.params[this.rootParams.selectedData.screenProps.sourceKey];
      }
    }

    this.driveService.fetchScreenProperties(parentScreenParam, templateProperty.id, (screenProps, gridRowData = null) => {
      let component = this.getComponent(templateProperty.componentName);
      let componentName = this.getComponent(screenProps.id);
      this.detailComponentHolder.clear();
      let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
      this.componentRef = this.detailComponentHolder.createComponent(componentFactory);
      this.componentRef.instance.componentName = componentName;
      this.componentRef.instance.params = parentScreenParam;
      this.componentRef.instance.screenProps = screenProps;
      this.componentRef.instance.templateName = screenProps.id;
      this.componentRef.instance.accessType = this.accessType;
      this.componentRef.instance.gridParam = this.gridParam;
      this.componentRef.instance.dataAccessType = this.dataAccessType;
      this.componentRef.instance.components = this.components;
      this.componentRef.instance.detailCompParams = this.detailCompParams;
    });
  }

  getFormLayout() {
    this.formLayout = this.screenProps.formLayout;
    if (!this.formLayout) {
      this.formLayout = [[{ "fields": [], "Id": "", "layoutName": "", "isVisibleHeader": "NO", "props": "" }]];
    }
    return this.formLayout;
  }

  validateFormLayout(formLayout) {
    let rowIdx = 0;
    let colIdx = 0;
    let fldIdx = 0;
    formLayout.forEach(cols => {
      cols.forEach(rows => {
        rows.fields.forEach(field => {
          if (field.FieldDataType === "DATE") {
            if (field.DefaultValue === "") {
              formLayout[colIdx][rowIdx].fields[fldIdx].DefaultValue = new Date();
            }
          }
          fldIdx = fldIdx + 1;
        });
        rowIdx = rowIdx + 1;
      });
      colIdx = colIdx + 1;
    });
    return formLayout;
  }


  /* * * * * * *
  * save header data
  * * * * * * */
  saveFormData(data) {
    this.handleMainFrom(data);
  }

  handleMainFrom(data) {

    this.formData = data;
    this.driveService.setFormDataToDb(this.screenProps.id, this.screenProps.fieldProperties, this.formData, this.response_Data);
  }

  response_Data = ((data) => {

    if (data.IsValid) {
      const toast = this.toastController.create({
        message: data.message,
        showCloseButton: false,
        duration: this.configApiService.toastDuration
      });
      toast.present();
      if (data.IsValid == true) {
        // this.params["user_id"] = data["user_id"]; 
        //@santhiya removed above line because of user id
        if (data.hasOwnProperty(Object.keys(this.params)[0]) && data.hasOwnProperty(Object.keys(this.params)[0]) != '') {
          this.params[Object.keys(this.params)[0]] = data[Object.keys(this.params)[0]];
          this.driveService.broadcastInfo({ src: 'header-detail', event: 'pushHeaderParamsValue', params: this.params });
        }
        this.loadComponent();
      }
    } else {
      const toast = this.toastController.create({
        message: data.message,
        showCloseButton: true,
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  });


  /* * * * * *
   * Assign Form Group Fields
   * * * * * */
  assignFormFields() {
    let fieldsCtrls = {};
    if (this.screenProps.formLayout) {
      for (let formFiled of this.screenProps.formLayout) {
        for (let layout of formFiled) {
          this.fields = layout['fields'];
          if (this.fields) {
            for (let f of this.fields) {
              if (f.FieldDataType === 'checkbox') {
                let opts = {};
                for (let opt of f.options) {
                  opts[opt.key] = new FormControl(opt.value);
                }
                fieldsCtrls[f.FieldName] = new FormGroup(opts)
              }
              else if (f.FieldDataType === 'SELECT') {
                let selectedOpt;
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.label === f.DefaultValue) {
                      selectedOpt = opt.key;
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl(selectedOpt ? selectedOpt : f.DefaultValue, Validators.required);
              }
              else if (f.FieldDataType === 'DYNAMIC-LOOKUP') {
                let selectedOpt;
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.label === f.DefaultValue) {
                      selectedOpt = opt.key;
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl(selectedOpt ? selectedOpt : f.DefaultValue, Validators.required);
              }
              else if (f.FieldDataType === 'MULTISELECT_V') {
                let selectedOpt;
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.item_id === f.DefaultValue) {
                      selectedOpt = opt;
                    } else {
                      selectedOpt = f.options[0];
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl(selectedOpt ? selectedOpt : [], Validators.required)
              }
              else {
                fieldsCtrls[f.FieldName] = new FormControl(f.DefaultValue, Validators.required)
              }
            }
            this.form = new FormGroup(fieldsCtrls);
          }
        }
      }
    }
    return this.form;
  }

  /* * * * * *
  * get Form data
  * * * * * */
  getFormFieldsData() {
    if (this.screenProps.formLayout) {
      for (let formFiled of this.screenProps.formLayout) {
        for (let layout of formFiled) {
          this.fields = layout['fields'];
          if (this.fields) {
            for (let f of this.fields) {
              this.formFields[f.FieldName] = f;
            }
          }
        }
      }
    }
    return this.formFields;
  }
  @ViewChild('ChatComponent', { read: ViewContainerRef, static: false }) ChatComponent: ViewContainerRef;
  openNavChat() {
    this.ChatComponent.clear();
    this.chatOpen = true;
    // let componentFactory = this.componentFactoryResolver.resolveComponentFactory(ChatComponent);
    // this.componentRef = this.ChatComponent.createComponent(componentFactory);

  }

  clearnavChat() {
    this.ChatComponent.clear();
  }

  openHeaderForm(screenProps) {
    // let value;
    // this.events.unsubscribe('openHeaderForm';
    let headerFormId, component, templateProperty
    headerFormId = JSON.parse(screenProps["pluginData"])["headerForm"] != undefined ? JSON.parse(screenProps["pluginData"])["headerForm"] : screenProps.id;
    let parentScreenParam = {};
    parentScreenParam[screenProps['sourceKey']] = this.params[this.screenProps['sourceKey']];
    if (screenProps.componentName != "FormGridComponent" && screenProps.componentName != "SEARCHGRID") {
      this.driveService.fetchScreenProperties(parentScreenParam, headerFormId, (headerFormScreenProps, gridRowData = null) => {

        component = this.getComponent(headerFormScreenProps.componentName);
        templateProperty = headerFormScreenProps;
        this.createSubComponent(templateProperty, component);
      })
    } else {
      this.driveService.getFormFieldData(this.params, screenProps, (headerFormScreenProps) => {

        component = this.getComponent(headerFormScreenProps.componentName);
        templateProperty = headerFormScreenProps;
        this.createSubComponent(templateProperty, component);
      })
    }
  }

  createSubComponent(templateProperty, component) {
    let field = {};
    field['FieldDataType'] = 'defaultFrom';
    let chilFormParams = {
      'field': field,
      'params': this.params,
      'isChildForm': true,
      'screenType': 'popup',
      'parentForm': this.form,
      'sourceField': this.sourceField,
      'sourceScreen': "",
      'screenProps': templateProperty,
      'screenName': this.driveService.objCurrentFolder['name'],
      'formAccessType': this.formAccessType,
    }
    if (!component) {
      component = this.components[0];
      var modalPage = this.modal.create(component['comp'], { 'chilFormParams': chilFormParams }, { cssClass: "modal-custom-field-type", showBackdrop: true, enableBackdropDismiss: false });
      modalPage.present();
    } else {
      var modalPage = this.modal.create(component['comp'], { 'chilFormParams': chilFormParams }, { cssClass: "modal-custom-field-type", showBackdrop: true, enableBackdropDismiss: false });
      modalPage.present();
    }
  }

  openHeaderAllForm() {
    this.setHeaderHeight = 'auto';
    this.headerOpen = false;
    this.headerClose = true;
  }
  closeHeaderAllForm() {
    this.setHeaderHeight = 60;
    this.headerClose = false;
    this.headerOpen = true;
  }
}


// WEBPACK FOOTER //
// ./src/components/header-detail/header-detail.ts